import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { Email, Phone, LocationOn } from '@mui/icons-material';

const ContactInfo = () => {
    const contactDetails = [
        {
            icon: <LocationOn sx={{ mr: 1.5, color: '#66bb6a' }} />,
            primary: 'International University of Business Agriculture and Technology',
            secondary: 'Dhaka, Bangladesh 🇧🇩'
        },
        {
            icon: <Email sx={{ mr: 1.5, color: '#66bb6a' }} />,
            primary: 'saikatgain.cse@gmail.com',
            secondary: 'Frontend & UI/UX Support'
        },
        {
            icon: <Phone sx={{ mr: 1.5, color: '#66bb6a' }} />,
            primary: '+880 1822-679672',
            secondary: 'Md. Alamin'
        }
    ];

    return (
        <>
            <Typography variant="h6" fontWeight={700} gutterBottom sx={{ color: '#66bb6a' }}>
                📞 Get In Touch
            </Typography>
            <Stack spacing={2}>
                {contactDetails.map((contact, index) => (
                    <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                        {contact.icon}
                        <Box>
                            <Typography variant="body2" fontWeight={600}>
                                {contact.primary}
                            </Typography>
                            {contact.secondary && (
                                <Typography variant="body2" sx={{ opacity: 0.8 }}>
                                    {contact.secondary}
                                </Typography>
                            )}
                        </Box>
                    </Box>
                ))}
            </Stack>

            {/* JavaFest 2025 Badge */}
            <Box sx={{ mt: 3, p: 2, background: 'rgba(102, 187, 106, 0.1)', borderRadius: 2 }}>
                <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                    🏆 JavaFest 2025 Project
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                    Built with ❤️ by <strong>The IUBAT Duo</strong> for a cleaner, greener Bangladesh.
                </Typography>
            </Box>
        </>
    );
};

export default ContactInfo;
